import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(() => ({}));

export default withCustomStyles;
